/**
 * i18n barrel exports.
 *
 * Re-exports all i18n utilities, types, and components for convenient imports.
 */

export { IntlProvider, useLocale } from './IntlProvider';
export { useFormatters } from './useFormatters';
export type { SupportedLocale, MessageId, Messages } from './types';

/** Default locale for the application. */
export const DEFAULT_LOCALE = 'pt-BR' as const;

/** All locales the application supports. */
export const SUPPORTED_LOCALES = ['pt-BR', 'en-US'] as const;

/**
 * Locale display names (in their own language) for UI selectors.
 */
export const LOCALE_DISPLAY_NAMES: Record<string, string> = {
  'pt-BR': 'Português (Brasil)',
  'en-US': 'English (US)',
};
